import { render, staticRenderFns } from "./Donors.vue?vue&type=template&id=0ba02b7c&scoped=true&"
import script from "./Donors.vue?vue&type=script&lang=tsx&"
export * from "./Donors.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba02b7c",
  null
  
)

export default component.exports